<div class="bg-body-tertiary">

<div class="container px-4 py-5  " id="featured-3">
  <img ngSrc="/assets/img/aboutUs/valores.svg" class="" width="60" height="60" alt="">
  <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Nuestros valores</h2>
  <div class="row g-4 py-5 row-cols-1 row-cols-lg-2">
    <div class="feature col">
      <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Compromiso</h2>
      <p class="fs-5 text-secondary">Creemos que cada una de nuestras acciones, individuales y en equipo, deben estar enfocadas en lograr el bienestar de nuestros usuarios, mediante un servicio de excelencia que nos diferencia de manera positiva.</p>
    </div>
    <div class="feature col">
      <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Confianza</h2>
      <p class="fs-5 text-secondary">Construimos relaciones de confianza al satisfacer las necesidades y superar las expectativas de nuestros usuarios y siendo responsables con nuestra conducta en el desarrollo de las actividades.</p>
    </div>
    <div class="feature col">
      <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Ética</h2>
      <p class="fs-5 text-secondary">Practicamos una conducta transparente, honesta y confiable en todos nuestros actos. Observamos el cumplimiento permanente de la ley y normativa vigente, y de los lineamientos internos.</p>
    </div>
    <div class="feature col">
      <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Actitud y Adaptabilidad</h2>
      <p class="fs-5 text-secondary">Valoramos el potencial que cada persona tiene para desarrollarse, asumir nuevos desafíos, enfrentar retos, alcanzar resultados; su capacidad de adaptación a situaciones o necesidades; y su actitud orientada hacia un trabajo de excelencia.</p>
    </div>
    <div class="feature col">
      <h2 class="pt-2 fs-2 fw-bold" style="color: var(--primary-color)">Respeto</h2>
      <p class="fs-5 text-secondary">Reconocemos el derecho de los demás (usuarios, clientes, colaboradores, prestadores, proveedores) al cumplir con nuestros deberes y obligaciones en un ambiente de respeto, cordialidad y con alto sentido humano.</p>
    </div>


  </div>
</div>


</div>
